import React, { useContext, useState } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { GatsbyLinkProps, Link, navigate } from 'gatsby';
import useWindowWidth from '../../hooks/useWindowWidth';

import Button from '../Button';
import SvgLogoWithRoller from '../fromSvg/SvgLogoWithRoller';
import SvgLogo from '../fromSvg/SvgLogo';
import SvgMenuArrowIcon from '../fromSvg/SvgMenuArrowIcon';
import BurgerMenu from './BurgerMenu';


const Header = styled.nav`
  z-index: 1000;
  position: fixed;
  width: 100%;
`;

const StyledNav = styled.div`
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  width: 100%;
  padding: 0 60px;
  height: ${({ theme }) => theme.navbarHeight.mobile};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    height: ${({ theme }) => theme.navbarHeight.desktop};
    justify-content: space-between;
  }
`;

const ItemsContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    justify-content: flex-start;
  }
`;

const OfferMenu = styled.div<{ isMenuOpened: boolean }>`
  margin-left: -30px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: inset 0 8px 8px -4px rgba(0, 0, 0, 0.25);
  & > * {
    margin: 20px 32px !important;
  }
  opacity: ${({ isMenuOpened }) => (isMenuOpened ? 1 : 0)};
  max-height: ${({ isMenuOpened }) => (isMenuOpened ? '400px' : 0)};
  overflow: hidden;
  transition: all 400ms ease-in-out;
  position: absolute;
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.dark};
  font-size: ${({ theme }) => theme.fontSize.small};
  text-transform: uppercase;
  text-decoration: none;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  margin-left: 10px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.large}){
    margin-left: 25px;
    font-size: ${({ theme }) => theme.fontSize.medium};
  }
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    margin-left: 90px;
  }
  &:hover {
    color: ${({ theme }) => theme.colors.orange};
  }
`;

const ItemContainer = styled.div`
  align-self: flex-start;
  margin-left: 10px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.large}){
    margin-left: 25px;
    font-size: ${({ theme }) => theme.fontSize.medium};
  }
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    margin-left: 90px;
  }
  & > a {
    margin-left: 0;
    height: ${({ theme }) => theme.navbarHeight.desktop};
    line-height: ${({ theme }) => theme.navbarHeight.desktop};
  }
`;

const StyledSvgMenuArrowIcon = styled(SvgMenuArrowIcon)`
  margin-left: 5px;
`;

const MenuItem = ({ ...props }: GatsbyLinkProps<{}>) => {
  const theme = useContext(ThemeContext);
  return (
    <>
      { /* @ts-ignore */}
      <StyledLink
        activeStyle={{ color: `${theme.colors.orange}`, borderBottom: `2px solid ${theme.colors.orange}` }}
        {...props}
      />
    </>
  );
};

const NavBar = () => {
  const windowWidth = useWindowWidth();
  const theme = useContext(ThemeContext);
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  if (typeof window === 'undefined') {
    return <></>;
  }
  return (
    <Header>
      { typeof document !== 'undefined' && (
        <StyledNav>
          {windowWidth < theme.screenSizeWidthWithoutPx.medium && (
            <Link to="/">
              <SvgLogo />
            </Link>
          )}
          {windowWidth >= theme.screenSizeWidthWithoutPx.medium && (
            <ItemsContainer>
              {windowWidth >= theme.screenSizeWidthWithoutPx.medium && (
                <Link to="/">
                  <SvgLogoWithRoller />
                </Link>
              )}
              <MenuItem
                to="/o-mnie"
              >
                O mnie
              </MenuItem>
              <MenuItem
                to="/realizacje"
              >
                Realizacje
              </MenuItem>
              <MenuItem
                to="/ile-to-kosztuje"
              >
                Ile to kosztuje
              </MenuItem>
              <ItemContainer
                onMouseEnter={() => setIsMenuOpened(true)}
                onMouseLeave={() => setIsMenuOpened(false)}
              >
                <MenuItem
                  to="/oferta"
                >
                  Oferta
                  <StyledSvgMenuArrowIcon height={13} />
                </MenuItem>
                <OfferMenu isMenuOpened={isMenuOpened}>
                  <MenuItem
                    to="/lazienka"
                  >
                    Łazienka
                  </MenuItem>
                  <MenuItem
                    to="/kuchnia"
                  >
                    Kuchnia
                  </MenuItem>
                  <MenuItem
                    to="/pokoj"
                  >
                    Pokój
                  </MenuItem>
                  <MenuItem
                    to="/kompleksowy-remont"
                  >
                    Wszystko
                  </MenuItem>
                  <MenuItem
                    to="/cos-innego"
                  >
                    Coś innego
                  </MenuItem>
                </OfferMenu>
              </ItemContainer>
              <MenuItem
                to="/kontakt"
              >
                Kontakt
              </MenuItem>
            </ItemsContainer>
          )}
          {windowWidth < theme.screenSizeWidthWithoutPx.medium && (
            <BurgerMenu />
          )}
          {windowWidth >= theme.screenSizeWidthWithoutPx.medium && (
            <Button onClick={() => navigate('/kontakt/#form')}>Skontaktuj się</Button>
          )}
        </StyledNav>
      )}
    </Header>
  );
};

export default NavBar;
